import React,{useContext, useLayoutEffect, useState, useEffect, useRef, useCallback} from 'react'
import {Row, Container} from 'react-bootstrap'
import ELEMENTS from '../ELEMENTS'
import styles from '../../css/ROW.module.css'
import {AppContext} from '../../../Resources/CanvasContextFile'
import AddColumn from '../../../Icons/AddColumn'
import Delete from '../../../Icons/Delete'
import styles2 from '../../css/COLUMN.module.css'
import ElemDeleteControl from "../ElemDeleteControlWrapper";
import {useDispatch,addContexts,useSelector} from "../../../Redux"
import { getTabIndex, handleDisplayProperty, updatePartialJSON, validIndexFunction } from '../../../components/IFormDesignerLayout/IFormDesignerLogic'
import { GetState, GetStateFromData, useElementWidth } from '../../../components/CustomHooks/CustomHooks'
import { functions } from '../../../components/IFormDesignerLayout/ApplicationAPI/applicationApi'

const ROW = (props) => {
  const isIBPSClient = window?.psh_configs?.isIBPSClient || false
  const contexts = GetStateFromData(props.containerId);
  const activeTabIndex = getTabIndex({...props.data, stepIndex: props?.stepIndex,sheetIndex: props?.sheetIndex,subStepIndex: props?.subStepIndex,sheetElementIndex: props?.data?.sheetElementIndex});
var isSubformInPage = props?.isSubformInPage || false;
  const {controlSelected,devicePreview, noOfRows} = GetState("controlSelected","devicePreview", "noOfRows");

  const reduxContexts=contexts;
  const {updateJson, IdPrecedence, setMax_controlIdValue ,deleteControl ,
    addColumn, formState2, device, openQuickToolFor, setLoginErrorPage,openCanvasForSubform}=contexts.contexts;

    const conditionalQuickToolOpening =
    props.id === openQuickToolFor ? true : false

    const css={height:'auto',
    border:'1px dashed grey',
    minHeight:'50px'};
    // //console.log('Row called, these are props:');
    const data = props.data;

    setMax_controlIdValue(props.data.id, "row");
   
    const children = data.children;
    var areChildrenPresent = false;

    // openCanvasForSubform === "showDataAdditonSection"
    var rowStyle={position:"relative"};

    var rowStyleForListView={position:"relative", marginLeft:"0px", marginRight:"0px"};


    var rowStylePreview={position:"relative"};

    var rowStylePreviewListview={ marginLeft:"0px", marginRight:"0px", position:"relative"};

    



    


    if(children!==null && children!==undefined){
        if(children.length===0){
            areChildrenPresent = true;
            rowStyle={
                position:"relative",
                // border: '1px dashed #ced4da', 
                // backgroundColor:'#F8F8F8'
            };
            if(!props.previewmode){
              rowStyle.border = '1px dashed #ced4da';
              rowStyle.backgroundColor ='#F8F8F8';
            }
            // if(props.id === props.selected.id){
            //     rowStyle.border = '1px dashed #000000';
            // } else {
                // rowStyle.border = '1px dashed #ced4da';
            // }
        } else {
            rowStyle={position:"relative"};
        }
    }

  //  //console.log('Row #'+data.id+' children-->'+JSON.stringify(children));

   // //console.log('Row #'+data.id+' children-->'+JSON.stringify(children));


    // const {deleteControl,addColumn} = useContext(AppContext);
    // const AppContextVar = useContext(AppContext);
    // let deleteControl;
    // let addColumn;
    // if(AppContextVar!==undefined){
    //     deleteControl = AppContextVar.deleteControl;
    //     addColumn = AppContextVar.addColumn;
    // }

    useEffect(() => {
      if(validIndexFunction(props.elementIndex) && !validIndexFunction(props.data.elementIndex))
        props.data.elementIndex = props.elementIndex;
      if(validIndexFunction(props.frameIndex) && !validIndexFunction(props.data.frameIndex))
        props.data.frameIndex = props.frameIndex;
      if(validIndexFunction(props.sheetIndex) && !validIndexFunction(props.data.sheetIndex))
        props.data.sheetIndex = props.sheetIndex;
      if(validIndexFunction(props.sheetElementIndex) && !validIndexFunction(props.data.sheetElementIndex))
        props.data.sheetElementIndex = props.sheetElementIndex;
      if(validIndexFunction(props.stepIndex) && !validIndexFunction(props.data.stepIndex))
        props.data.stepIndex = props.stepIndex;
      if(validIndexFunction(props.subStepIndex) && !validIndexFunction(props.data.subStepIndex))
        props.data.subStepIndex = props.subStepIndex;
    },[])

    useEffect(() => {
        let flag = false;
        if(props?.isSubForm && !props?.data?.isSubForm) {
        props.data.isSubForm = props?.isSubForm;
        flag = true;
        }
        if(props?.buttonId && props?.data?.buttonId !== props?.buttonId) {
        props.data.buttonId = props?.buttonId;
        flag = true;
        }
        //if(flag)
          //updatePartialJSON(props.data.id,props.data);
    },[props?.isSubForm, props?.buttonId])

    useEffect(() => {
      if (props?.previewmode) {
        let hideRow = false;
  
        if (children?.length >= 0) {
          hideRow = children.every(
            (child) => (child?.style?.["Visible"] === "false" || child?.style?.["Visible"] === false)
          );
        }
        if(document.getElementById(props?.data?.id) && hideRow) {
            document.getElementById(props.data.id).style.display = 'none';
        } else if( document.getElementById(props?.data?.id) ) {
          document.getElementById(props.data.id).style.display = 'flex';
        }
      }
    },[JSON.stringify(props?.data?.children)]);

    function highlightElement(){
        //console.log('highlightElement!');
        // rowStyle.animation = 'pulse 3s infinite';
    }
    function stopHighlightElement(){ 
        // //console.log('stopHighlightElement!');
        rowStyle.animation = undefined;
    }

    var parent_id=data.parent_id;
    if(parent_id==="RootControl"){
      parent_id=props?.parentframeId;
    }

    // const [sectionJson, setSectionJson] = useState([]);

    // useEffect(() => {
    //   if(!props?.previewmode){
    //     const json = functions.readJson(formState2,props?.parentframeId);
    //     setSectionJson(json);
    //   }
    // },[props?.parentframeId])

    // const countofRows = (data) => {
    //   let count = 0;
    //   for(let i = 0; i < data?.length; i++)
    //   {
    //     if(data[i].elem_type === 'row')
    //       count++;
    //   }
    //   return count;
    // }

    // const findNoOfRows = (frameId) => {
  
    //   return countofRows(sectionJson.children);
    // }

    // let noOfRows;
    // if(!props?.previewmode){
    //   noOfRows = countofRows(sectionJson?.children);
    // }

    // Using useCallback to memoize a function
    const handleHiglightRow = useCallback(() => {
      if (!props.previewmode) {
        const ele = document.getElementById(props.id);
        const after_row = document.getElementById('after_' + props.id);
        const before_row = document.getElementById('before_' + props.id);
  
        // Define event handlers separately to clean them up properly later
        const dragEnterHandler = (e) => {
          e.preventDefault();
          ele.classList.add('dragging');
        };
  
        const dragOverHandler = (e) => {
          e.preventDefault();
        };
  
        const dragLeaveHandler = (e) => {
          e.preventDefault();
          ele.classList.remove('dragging');
        };
  
        const dropHandler = (e) => {
          e.preventDefault();
          ele.classList.remove('dragging');
        };
  
        const beforeDragEnterHandler = (e) => {
          e.preventDefault();
          before_row.classList.add('highlightedRow');
        };
  
        const beforeDragLeaveHandler = (e) => {
          e.preventDefault();
          before_row.classList.remove('highlightedRow');
        };
  
        const beforeDropHandler = (e) => {
          e.preventDefault();
          before_row.classList.remove('highlightedRow');
        };
  
        const afterDragEnterHandler = (e) => {
          e.preventDefault();
          after_row.classList.add('highlightedRow');
        };
  
        const afterDragLeaveHandler = (e) => {
          e.preventDefault();
          after_row.classList.remove('highlightedRow');
        };
  
        const afterDropHandler = (e) => {
          e.preventDefault();
          after_row.classList.remove('highlightedRow');
        };
  
        // Check and attach event listeners for `ele`
        if (ele) {
          ele.addEventListener('dragenter', dragEnterHandler);
          ele.addEventListener('dragover', dragOverHandler);
          ele.addEventListener('dragleave', dragLeaveHandler);
          ele.addEventListener('drop', dropHandler);
          ele.setAttribute("listener", "true");
        }
  
        // Check and attach event listeners for `after_row`
        if (after_row) {
          after_row.setAttribute('control_id', props.data?.parent_id);
          after_row.addEventListener('dragenter', afterDragEnterHandler);
          after_row.addEventListener('dragover', dragOverHandler);
          after_row.addEventListener('dragleave', afterDragLeaveHandler);
          after_row.addEventListener('drop', afterDropHandler);
          after_row.setAttribute("listener", "true");
        }
  
        // Check and attach event listeners for `before_row`
        if (before_row) {
          before_row.setAttribute('control_id', props.data?.parent_id);
          before_row.addEventListener('dragenter', beforeDragEnterHandler);
          before_row.addEventListener('dragover', dragOverHandler);
          before_row.addEventListener('dragleave', beforeDragLeaveHandler);
          before_row.addEventListener('drop', beforeDropHandler);
          before_row.setAttribute("listener", "true");
        }
  
        // Cleanup function to remove event listeners when the component unmounts or dependencies change
        return () => {
          if (ele) {
            ele.removeEventListener('dragenter', dragEnterHandler);
            ele.removeEventListener('dragover', dragOverHandler);
            ele.removeEventListener('dragleave', dragLeaveHandler);
            ele.removeEventListener('drop', dropHandler);
          }
  
          if (before_row) {
            before_row.removeEventListener('dragenter', beforeDragEnterHandler);
            before_row.removeEventListener('dragover', dragOverHandler);
            before_row.removeEventListener('dragleave', beforeDragLeaveHandler);
            before_row.removeEventListener('drop', beforeDropHandler);
          }
  
          if (after_row) {
            after_row.removeEventListener('dragenter', afterDragEnterHandler);
            after_row.removeEventListener('dragover', dragOverHandler);
            after_row.removeEventListener('dragleave', afterDragLeaveHandler);
            after_row.removeEventListener('drop', afterDropHandler);
          }
        };
      }
    }, []);
    
    useLayoutEffect(()=>{
      const cleanup = handleHiglightRow();
      // Call cleanup when the component unmounts or props change
      return () => cleanup && cleanup();
    }, [props?.data?.children]);

    var before_rowIndicator = null;

    const after_rowIndicator = 
    <div row_id={props.id} id={"after_"+props.id} control_id={props.id} parent_id={props.tabsheetId || parent_id} 
      className={styles.afterRow} 
      elem_type='row' key={'after_'+props.id}
      frameindex={data.frameIndex} row_index={props.row_index} elementIndex={props.elementIndex} 
      sheetIndex={props.sheetIndex} sheetElementIndex={props.sheetElementIndex}>

    </div>;
    if(props.row_index!==null && props.row_index!==undefined){
        if(parseInt(props.row_index)===1){
            before_rowIndicator = 
            <div row_id={props.id} id={"before_"+props.id} control_id={props.id} parent_id={props.tabsheetId || parent_id} 
              className={styles.afterRow} elem_type='row' key={'before_'+props.id}
              frameindex={data.frameIndex} row_index={props.row_index} 
              elementIndex={props.elementIndex} sheetIndex={props.sheetIndex} sheetElementIndex={props.sheetElementIndex}
            style={{padding:(props.ReadOnlyStyle==='true')?'1px':null}}>
              
            </div>;
        }
        // //console.log('Row Index :: '+props.row_index+' , '+props.id);
    } else {
        // //console.log('Row Index does not exist!');
    }
    // section_back_color={props.section_back_color}
    //console.log('ROW ReadOnlyStyle :: '+props.data.id, props.ReadOnlyStyle);

    let conditionalRowCssClass = styles.row_css;
    if (children && children.length>0){
        conditionalRowCssClass = styles.row_css_withChildren;
    }
      if (props.previewmode) {
        return (
          <>
            {/* {before_rowIndicator} */}
            <Row
              className={isIBPSClient ? styles.row_cssPreviewIBPS : styles.row_cssPreview}
              // className={styles.row_css}
              // style={mobileDisplay === false || tabDisplay === false ? {display:"none"} : 
              // {display:"block"}}
              elem_type="row"
              key={props.id}
              id={props.id}
              data-placement="top"
              frameindex={data.frameIndex}
              // onClick={(e)=>props.handleSelected(e,props.id,"n")}
              // style={{position:"relative"}}
              style={{...rowStyle, marginLeft: "0px",marginRight:"0px"}}
              // style={rowStyle}
              // style={openCanvasForPreview === "showDataAdditonSection"  ?  rowStylePreviewListview : rowStylePreview }
              row_index={props.row_index}
              // tabIndex="1"
              // onDragOver={highlightElement}
              // onDragLeave={stopHighlightElement}
              previewmode={props.previewmode}
              section_back_color={props.section_back_color}
              elementIndex={props.elementIndex}
              sheetIndex={props.sheetIndex}
              sheetElementIndex={props.sheetElementIndex}
            >
              {children
                ? children && (
                    <>
                      {props.renderChild}
                    </>
                  )
                : null}
            </Row>
            {/* {after_rowIndicator} */}
          </>
        );
      } 
      else {
        return (
          <>
            {before_rowIndicator}
            <Row
              // className={styles.row_css}
              className={conditionalRowCssClass}
              elem_type="row"
              key={props.id}
              id={props.id}
              data-placement="top"
              frameindex={data.frameindex || data.frameIndex}
              onClick={(e) => props.handleSelected(e, props.id, "n")}
              
              // style={{position:"relative"}}
              // style={rowStyle}
              style={openCanvasForSubform === "showDataAdditonSection"  ?  rowStyleForListView : {...rowStyle,marginLeft: "0px",marginRight:"0px"} }
              tabIndex={activeTabIndex}
              row_index={props.row_index}
              elementIndex={data.elementIndex || props.elementIndex}
              sheetIndex={props.sheetIndex}
              sheetElementIndex={props.sheetElementIndex}

              // onDragOver={highlightElement}
              // onDragLeave={stopHighlightElement}
            >
              {children
                ? props &&
                  children && (
                    <>
                      {props.renderChild}
                      {
                        // controlSelected?.id === props?.id && children.length === 0 && (noOfRows > 1 || props?.data?.sheetId) && 
                        controlSelected?.id === props?.id &&
                        children.length === 0 &&
                        ((props?.data?.parent_id && props?.data?.parent_id.includes("sheet")) ||
                          (props?.tabsheetId && props?.tabsheetId?.includes("sheet")) ||
                        noOfRows > 1 ||
                        props?.data?.sheetId ) && 

                      <ElemDeleteControl
                      isSubformInPage={isSubformInPage}
                      containerId={props.containerId}
                        id={props.id}
                        data={props.data}
                        deleteControl={deleteControl}
                        elemType={props.data.elem_type}
                      />
                      }
                    </>
                  )
                : null}
            </Row>
            {after_rowIndicator}
          </>
        );
      }

}

export default ROW